import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Button from "../../common/button/button";
import Select from "../../common/form/select";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import * as am4core from "@amcharts/amcharts4/core";
import { setError, setInfo } from "../../common/toast/toast.jsx";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    getDemanda,
    getListaGraficoCustoAnual,
    getListaCustoPorUnidadePeriodo,
    getListaGraficoCustoPorUnidadeMensal,
    getListaGraficoCustoPorUnidadeAcumuladoAno,
    getListarGraficoCustoJurosPorAtrasoPagamentoAnual,
    getListarGraficoCustoJurosPorAtrasoPagamentoMensal,
    getListaGraficoCustoPorUnidadeAnual,
    setFiltro,
} from "../analiseActions";

import { gerarRelatorio, setListaFaturasRedirecionamento } from "../../fatura/faturaActions.js";

import { montarGraficoColumn } from "../../common/graficos/montarGraficoColumn.js";
import { montarGraficoGroupColumn } from "../../common/graficos/montarGraficoGroupColumn.js";
import { montarGraficoClusteredColumnMensalSafra } from "../../common/graficos/montarGraficoClusteredColumnMensalSafra.js";
import { montarGraficoClusteredColumnMensal } from "../../common/graficos/montarGraficoClusteredColumnMensal.js";
import { montarGraficoClusteredColumnAnual } from "../../common/graficos/montarGraficoClusteredColumnAnual.js";
import { montarGraficoClusteredColumnGrupo } from "../../common/graficos/montarGraficoClusteredColumnGrupo.js";
import { montarGraficoHorizontalBar } from "../../common/graficos/montarGraficoHorizontalBar.js";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import { montarGraficoGroupStackedColumn } from "../../common/graficos/montarGraficoGroupStackedColumn.js";
import { Loading } from "../../common/loading/loading";
import NewTr from "../../common/table/newTr.jsx";
import AlertIcon from "../../common/alertIcon/alertIcon.jsx";
import { TabelaPrevisorCustos } from "../components/TabelaPrevisorCustos.jsx";
import { coeficienteVariacao, media, variacao } from "../../utils/calculator.js";
import { TextInPill } from "../../common/textInPill/TextInPill.jsx";
import DateFormat from "../../common/dateFormat/DateFormat.js";
import { ModalSimularFaturaPendentePrevisorCustos } from "../components/ModalSimularFaturaPendentePrevisorCustos.jsx";
import { ModalSelecionarModoPrevisorCustos } from "../components/ModalSelecionarModoPrevisorCustos.jsx";

function AnaliseCustoComponent(props) {
    if (!props.visible) return null;

    const {
        state,
        usuarioLogado,
        listar,
        contratoDemanda,
        listaGraficoCustoAnual,
        listaGraficoCustoPorUnidadeAcumuladoAno,
        listaGraficoCustoJurosPorAtrasoPagamentoAnual,
        listaGraficoCustoJurosPorAtrasoPagamentoMensal,
        listaUnidadeConsumidora,
        listaGraficoCustoUnidadeAnual,
        listaGraficoCustoUnidadeMensal,
        listaCustoPorUnidadePeriodo,
        filtro,
        getDemanda,
        getListaGraficoCustoAnual,
        getListaCustoPorUnidadePeriodo,
        getListaGraficoCustoPorUnidadeMensal,
        getListaGraficoCustoPorUnidadeAcumuladoAno,
        getListarGraficoCustoJurosPorAtrasoPagamentoAnual,
        getListarGraficoCustoJurosPorAtrasoPagamentoMensal,
        getListaGraficoCustoPorUnidadeAnual,
        setAguardando,
        gerarRelatorio,
        setFiltro,
        setListaFaturasRedirecionamento,
        listaAnos,
        instanteUltimaAnalise,
    } = props;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [listaModalFaturasSemImportacao, setListaModalFaturasSemImportacao] = useState([]);
    const [graficoCustoAnual, setGraficoCustoAnual] = useState(null);
    const [graficoCustoMensal, setGraficoCustoMensal] = useState(null);
    const [graficoCustoUnidadeAnual, setGraficoCustoUnidadeAnual] = useState(null);
    const [graficoCustoUnidadeMensal, setGraficoCustoUnidadeMensal] = useState(null);
    const [graficoCustoPorUnidadeAcumuladoAno, setGraficoCustoPorUnidadeAcumuladoAno] = useState(null);
    const [graficoCustoJurosPorAtrasoPagamentoAnual, setGraficoCustoJurosPorAtrasoPagamentoAnual] = useState(null);
    const [graficoCustoJurosPorAtrasoPagamentoMensal, setGraficoCustoJurosPorAtrasoPagamentoMensal] = useState(null);
    const [exibirPrevisorCustosMensal, setExibirPrevisorCustosMensal] = useState(false);
    const [ultimoInstanteBusca, setUltimoInstanteBusca] = useState(null);
    const [mesesPendentePrevisorCustos, setMesesPendentePrevisorCustos] = useState(null);
    const [competenciaFocoModalPrevisorCustos, setCompetenciaFocoModalPrevisorCustos] = useState(null);
    const [simulacoesPrevisorCustos, setSimulacoesPrevisorCustos] = useState([]);
    const [projecoesPrevisorCustos, setProjecoesPrevisorCustos] = useState([]);
    const [mensagemModalPrevisorCustos, setMensagemModalPrevisorCustos] = useState(null);
    const [modoValidacaoPendenciasPrevisorCustos, setModoValidacaoPendenciasPrevisorCustos] = useState("seguro");
    const [dadosPrevisorCustos, setDadosPrevisorCustos] = useState({
        listaMediaPorMes: [],
        listaCoeficienteVariacaoPorMes: [],
        listaGraficoCustoAnualZeroFill: {},
        ultimoAnoCustoTodosMesesCompletos: null,
    });
    const [detalharCustosMercadoLivre, setDetalharCustosMercadoLivre] = useState(null);

    const ucsMercadoLivre = listaUnidadeConsumidora.filter(
        (uc) =>
            (!filtro.unidades_consumidoras.length || filtro.unidades_consumidoras.find((ucFiltro) => ucFiltro.value == uc.id)) &&
            uc.id_cliente == filtro.id_cliente &&
            uc.id_tipo_mercado == 2
    );
    const anosCusto = calcularAnosCusto(listaGraficoCustoAnual);
    const { listaMediaPorMes, listaCoeficienteVariacaoPorMes, listaGraficoCustoAnualZeroFill, ultimoAnoCustoTodosMesesCompletos } = dadosPrevisorCustos;
    const listaMesesPendentesPrevisorCustos = getMesesPendentesPrevisorCustos(listaGraficoCustoAnualZeroFill);
    const listaMesesPendentesPrevisorCustosAteMesAtual = getMesesPendentesPrevisorCustosAteMesAtual(listaMesesPendentesPrevisorCustos);
    const pendenciasPrevisorCustosEditaveis = projecoesPrevisorCustos.length === 0;

    const aguardandoAnterior = useRef(state.aguardando);

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        if (!instanteUltimaAnalise || state.aguardando || ultimoInstanteBusca === instanteUltimaAnalise) return;

        setSimulacoesPrevisorCustos([]);
        setProjecoesPrevisorCustos([]);
        setMensagemModalPrevisorCustos(null);
        setModoValidacaoPendenciasPrevisorCustos("seguro");
        setDadosPrevisorCustos(calcularMedianaAndCoeficienteVariacao(anosCusto, listaGraficoCustoAnual, [], "seguro"));
        setUltimoInstanteBusca(instanteUltimaAnalise);
    }, [instanteUltimaAnalise, state.aguardando, listaGraficoCustoAnual]);

    useEffect(() => {
        if (!ultimoInstanteBusca) return;

        setDadosPrevisorCustos(calcularMedianaAndCoeficienteVariacao(anosCusto, listaGraficoCustoAnual, simulacoesPrevisorCustos, modoValidacaoPendenciasPrevisorCustos));
    }, [simulacoesPrevisorCustos, modoValidacaoPendenciasPrevisorCustos]);

    const exibirTabelaCustoMensal = instanteUltimaAnalise && ultimoInstanteBusca === instanteUltimaAnalise;

    useEffect(() => {
        setExibirPrevisorCustosMensal(false);
        setProjecoesPrevisorCustos([]);
        setMensagemModalPrevisorCustos(null);
    }, [exibirTabelaCustoMensal]);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([
                getDemanda(),
                getListaGraficoCustoAnual(),
                getListaCustoPorUnidadePeriodo(),
                getListaGraficoCustoPorUnidadeMensal(),
                getListaGraficoCustoPorUnidadeAcumuladoAno(),
                getListarGraficoCustoJurosPorAtrasoPagamentoAnual(),
                getListarGraficoCustoJurosPorAtrasoPagamentoMensal(),
                getListaGraficoCustoPorUnidadeAnual(),
            ]);
            setAguardando(false);
        };

        buscarDados();
    }, [state.aguardando]);

    // Atualiza os gráficos após a finalização das buscas, evitando a necessidade de clicar duas vezes em Atualizar.
    useEffect(() => {
        if (aguardandoAnterior.current && !state.aguardando) {
            atualizarTodosGraficos();
        }
        aguardandoAnterior.current = state.aguardando;
    }, [state.aguardando]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoCustoAnual();
        atualizarListaGraficoCustoPorUnidadeAnual();
        atualizarListaGraficoCustoPorUnidadeMensal();
        atualizarListaGraficoCustoPorUnidadeAcumuladoAno();
        atualizarListaGraficoCustoJurosPorAtrasoPagamentoAnual();
        atualizarListaGraficoCustoJurosPorAtrasoPagamentoMensal();
    }

    function desmontarTodosGraficos() {
        if (graficoCustoAnual) graficoCustoAnual.dispose();
        if (graficoCustoMensal) graficoCustoMensal.dispose();
        if (graficoCustoUnidadeAnual) graficoCustoUnidadeAnual.dispose();
        if (graficoCustoUnidadeMensal) graficoCustoUnidadeMensal.dispose();
        if (graficoCustoPorUnidadeAcumuladoAno) graficoCustoPorUnidadeAcumuladoAno.dispose();
        if (graficoCustoJurosPorAtrasoPagamentoAnual) graficoCustoJurosPorAtrasoPagamentoAnual.dispose();
        if (graficoCustoJurosPorAtrasoPagamentoMensal) graficoCustoJurosPorAtrasoPagamentoMensal.dispose();
        setExibirPrevisorCustosMensal(false);
    }

    function abrirPrevisorCustosMensal(modoValidacaoPendencias, dadosCalculados = null) {
        const dadosCalculadosPrevisorCustos =
            dadosCalculados || calcularMedianaAndCoeficienteVariacao(anosCusto, listaGraficoCustoAnual, simulacoesPrevisorCustos, modoValidacaoPendencias);

        if (!dadosCalculadosPrevisorCustos.ultimoAnoCustoTodosMesesCompletos) {
            setDadosPrevisorCustos(dadosCalculadosPrevisorCustos);
            return;
        }

        setModoValidacaoPendenciasPrevisorCustos(modoValidacaoPendencias);
        setDadosPrevisorCustos(dadosCalculadosPrevisorCustos);
        setDetalharCustosMercadoLivre(null);
        setExibirPrevisorCustosMensal(true);
    }

    function getAnoAnteriorAtual() {
        return new Date().getFullYear() - 1;
    }

    function anoTemTodosMesesComCustoMaiorQueZero(dadosCalculadosPrevisorCustos, ano) {
        const mesesAno = dadosCalculadosPrevisorCustos.listaGraficoCustoAnualZeroFill[ano] || [];
        return mesesAno.length === 12 && mesesAno.every((itemMes) => parseFloat(itemMes.custo_total || 0) > 0);
    }

    function abrirPrevisorCustosMensalAutomatico() {
        const anoAnterior = getAnoAnteriorAtual();
        const ultimoAnoCompletoSeguro = parseInt(ultimoAnoCustoTodosMesesCompletos);

        if (ultimoAnoCompletoSeguro === anoAnterior) {
            abrirPrevisorCustosMensal("seguro", dadosPrevisorCustos);
            return;
        }

        const dadosModoInconsistente = calcularMedianaAndCoeficienteVariacao(anosCusto, listaGraficoCustoAnual, simulacoesPrevisorCustos, "ignorando_pendencias");

        if (anoTemTodosMesesComCustoMaiorQueZero(dadosModoInconsistente, anoAnterior)) {
            abrirPrevisorCustosMensal("ignorando_pendencias", dadosModoInconsistente);
            setMensagemModalPrevisorCustos({
                titulo: "Previsor gerado em modo inconsistente",
                mensagem: `O previsor foi gerado em modo inconsistente porque ${anoAnterior} (ano anterior) não está com todos os meses completos.`,
            });
            return;
        }

        setDadosPrevisorCustos(dadosModoInconsistente);
        setExibirPrevisorCustosMensal(false);
        setMensagemModalPrevisorCustos({
            titulo: "Não foi possível gerar o previsor",
            mensagem: "Não é possível gerar o previsor porque todos os anos possuem algum mês incompleto ou zerado.",
        });
    }

    function atualizarListaGraficoCustoAnual(args = {}) {
        const { projecaoMensal } = args;

        let graficoCustoAnualAtualizado = null;

        if (ucsMercadoLivre.length) {
            const dados = [];
            listaGraficoCustoAnual.forEach((mes) => {
                mes.anos.forEach((itemAno) => {
                    const itemExiste = dados.find((item) => item.ano == itemAno.ano);
                    if (!itemExiste) {
                        dados.push({
                            ano: "" + itemAno.ano,
                            valor: parseFloat(itemAno.valor) || 0,
                            custo_gestao_acl: parseFloat(itemAno.custo_gestao_acl) || 0,
                            contribuicao_associativa_ccee: parseFloat(itemAno.contribuicao_associativa_ccee) || 0,
                            custo_energia_acl_lp: parseFloat(itemAno.custo_energia_acl_lp) || 0,
                            custo_energia_acl_cp: parseFloat(itemAno.custo_energia_acl_cp) || 0,
                        });
                    } else {
                        itemExiste.valor += parseFloat(itemAno.valor) || 0;
                        itemExiste.custo_gestao_acl += parseFloat(itemAno.custo_gestao_acl) || 0;
                        itemExiste.contribuicao_associativa_ccee += parseFloat(itemAno.contribuicao_associativa_ccee) || 0;
                        itemExiste.custo_energia_acl_lp += parseFloat(itemAno.custo_energia_acl_lp) || 0;
                        itemExiste.custo_energia_acl_cp += parseFloat(itemAno.custo_energia_acl_cp) || 0;
                    }
                });
            });
            dados.sort((a, b) => String(a.ano).substring(0, 4) - String(b.ano).substring(0, 4));
            graficoCustoAnualAtualizado = montarGraficoGroupStackedColumn({
                state: {
                    cores: [am4core.color("#009de6"), am4core.color("#6a54dc"), am4core.color("#530aff"), am4core.color("#005ef4"), am4core.color("#1b24cd")],
                },
                component: graficoCustoAnual,
                nome: "graficoCustoAnual",
                dados,
                category: "ano",
                valuesAndNames: [
                    { value: "valor", name: "Custo Distribuidora", stacked: true, linePattern: false },
                    { value: "custo_gestao_acl", name: "Custo de Gestão ACL", stacked: true, linePattern: false, hideZeroBullet: true },
                    { value: "contribuicao_associativa_ccee", name: "Contribuição Associativa CCEE", stacked: true, linePattern: false, hideZeroBullet: true },
                    { value: "custo_energia_acl_lp", name: "Custo Energia ACL LP", stacked: true, linePattern: false, hideZeroBullet: true },
                    { value: "custo_energia_acl_cp", name: "Custo Energia ACL CP", stacked: true, linePattern: false, hideZeroBullet: true },
                ],
                titulo: `Custo Total (R$)`,
                fontSizeTitle: 18,
                fontWeightTitle: "bolder",
                prefixo: "R$",
                sufixo: "",
                positionBullet: 0,
                dimensions: "3D",
                mostrarLegenda: true,
                chartBackground: "#30303d",
                bullets: true,
                nameSerieBullets: "Custo Distribuidora",
                dxIcone: 25,
                hideExport: true,
                centralizarVerticalmente: true,
                exibirBulletTotalizadorSeries: true,
            });
        } else {
            graficoCustoAnualAtualizado = montarGraficoClusteredColumnAnual({
                state,
                component: graficoCustoAnual,
                nome: "graficoCustoAnual",
                dados: listaGraficoCustoAnual,
                titulo: "Custo Total (R$)",
                prefixo: "R$",
                sufixo: "",
            });
        }

        setGraficoCustoAnual(graficoCustoAnualAtualizado);

        const montarGraficoMensal = filtro.custo_ano_safra ? montarGraficoClusteredColumnMensalSafra : montarGraficoClusteredColumnMensal;
        const listaCustoMensalComMercadoLivre = listaGraficoCustoAnual.map((mes) => {
            const anos = mes.anos.map((itemAno) => {
                return {
                    ano: "" + itemAno.ano,
                    valor:
                        (parseFloat(itemAno.valor) || 0) +
                        (parseFloat(itemAno.custo_gestao_acl) || 0) +
                        (parseFloat(itemAno.contribuicao_associativa_ccee) || 0) +
                        (parseFloat(itemAno.custo_energia_acl_lp) || 0) +
                        (parseFloat(itemAno.custo_energia_acl_cp) || 0),
                };
            });

            return {
                ...mes,
                anos,
            };
        });

        const graficoCustoMensalAtualizado = montarGraficoMensal({
            state: state,
            component: graficoCustoMensal,
            nome: "graficoCustoMensal",
            dados: listaCustoMensalComMercadoLivre,
            seriesLinhas: projecaoMensal,
            configSeriesLinhas: [
                {
                    sufixoSerie: "projecao",
                    descricao: "Projeção",
                    campo: "custo_total",
                    color: "#0b2144",
                },
                {
                    sufixoSerie: "desvio-negativo",
                    descricao: "Desvio (-)",
                    campo: "valorDesvioNegativo",
                    color: "#3bbaff",
                },
                {
                    sufixoSerie: "desvio-positivo",
                    descricao: "Desvio (+)",
                    campo: "valorDesvioPositivo",
                    color: "#17ba60",
                },
            ],
            titulo: "Custo Mensal (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoMensal(graficoCustoMensalAtualizado);
    }

    function atualizarListaGraficoCustoPorUnidadeAnual() {
        const graficoCustoUnidadeAnualAtualizado = montarGraficoClusteredColumnGrupo(
            state,
            graficoCustoUnidadeAnual,
            "graficoCustoUnidadeAnual",
            listaGraficoCustoUnidadeAnual.filter(
                (item) => !(filtro.unidades_custo_anual || []).length || (filtro.unidades_custo_anual || []).find((itemFiltro) => itemFiltro.label == item.agrupador)
            ),
            "Custo por Unidade em Períodos Definidos (para controle de custo por atividade)",
            "R$",
            ""
        );
        setGraficoCustoUnidadeAnual(graficoCustoUnidadeAnualAtualizado);
    }

    function atualizarListaGraficoCustoPorUnidadeMensal() {
        const montarGrafico = filtro.custo_ano_safra ? montarGraficoClusteredColumnMensalSafra : montarGraficoClusteredColumnMensal;
        const graficoCustoUnidadeMensalAtuaizado = montarGrafico({
            state: state,
            component: graficoCustoUnidadeMensal,
            nome: "graficoCustoUnidadeMensal",
            dados: listaGraficoCustoUnidadeMensal.map((item) => ({
                mes: item.mes,
                anos: item.tipos
                    .filter((tipo) => !(filtro.unidades_custo_anual || []).length || (filtro.unidades_custo_anual || []).find((itemFiltro) => itemFiltro.label == tipo.tipo))
                    .map((tipo) => ({
                        ano: tipo.tipo.substring(0, 20) + (tipo.tipo.length > 20 ? "..." : ""),
                        valor: tipo.valor || 0,
                    })),
            })),
            titulo: "Custo Mensal por Unidade (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoUnidadeMensal(graficoCustoUnidadeMensalAtuaizado);
    }

    function mapearListaGraficoColunasAgrupadas(lista) {
        const listaMapeada = [];
        const nomeColuna = filtro.custo_ano_safra ? "ano_inicio_fim_safra" : "ano";
        const anos = [];

        try {
            //monta uma lista com todos os anos existentes em todos meses
            for (const registro of lista) {
                const listaAnoValor = registro.itens.filter((item) => item[nomeColuna]); //remove registro com ano nulo
                for (const item of listaAnoValor) {
                    const ano = item[nomeColuna];
                    if (!anos.includes(ano)) {
                        anos.push(ano);
                    }
                }
            }
            anos.sort((a, b) => {
                return filtro.custo_ano_safra ? parseInt(a.split("/")[0]) - parseInt(b.split("/")[0]) : parseInt(a) - parseInt(b);
            });
            //percorre todos os meses
            for (const registro of lista) {
                //se encontrar o ano do mes na lista de anos, pega o respectivo valor, senao define o valor zero para o ano
                const colunas = { mes: registro.mes };
                for (const ano of anos) {
                    const anoExisteNoMes = registro.itens.find((item) => item[nomeColuna] == ano);
                    if (anoExisteNoMes && parseFloat(anoExisteNoMes.valor)) {
                        colunas[ano] = parseFloat(anoExisteNoMes.valor);
                    } else {
                        colunas[ano] = 0;
                    }
                }
                listaMapeada.push(colunas);
            }
            return {
                dados: listaMapeada,
                valuesAndNames: anos.map((item) => ({ value: item, name: item })),
            };
        } catch (erro) {
            console.log(erro);
            setError("Erro ao gerar gráficos de custo");
            return {
                dados: [],
                valuesAndNames: [],
            };
        }
    }

    function atualizarListaGraficoCustoJurosPorAtrasoPagamentoAnual() {
        const graficoCustoJurosPorAtrasoPagamentoAtualAtualizado = montarGraficoColumn({
            state,
            component: graficoCustoJurosPorAtrasoPagamentoAnual,
            nome: "graficoCustoJurosPorAtrasoPagamentoAnual",
            dados: listaGraficoCustoJurosPorAtrasoPagamentoAnual,
            category: filtro.custo_ano_safra ? "ano_inicio_fim_safra" : "ano",
            value: "valor",
            titulo: `Custo de Juros por Atraso de Pagamento por ${filtro.custo_ano_safra ? "Safra" : "Ano"} (R$)`,
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoJurosPorAtrasoPagamentoAnual(graficoCustoJurosPorAtrasoPagamentoAtualAtualizado);
    }

    function atualizarListaGraficoCustoJurosPorAtrasoPagamentoMensal() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoCustoJurosPorAtrasoPagamentoMensal);
        const graficoCustoJurosPorAtrasoPagamentoMensalAtualizado = montarGraficoGroupColumn({
            state,
            component: graficoCustoJurosPorAtrasoPagamentoMensal,
            nome: "graficoCustoJurosPorAtrasoPagamentoMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: "Custo de Juros por Atraso de Pagamento (R$)",
            prefixo: "R$",
            sufixo: "",
            dimensions: "3D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
        });
        setGraficoCustoJurosPorAtrasoPagamentoMensal(graficoCustoJurosPorAtrasoPagamentoMensalAtualizado);
    }

    function atualizarListaGraficoCustoPorUnidadeAcumuladoAno() {
        const graficoCustoPorUnidadeAcumuladoAnoAtualizado = montarGraficoHorizontalBar({
            component: graficoCustoPorUnidadeAcumuladoAno,
            chartDivId: "graficoCustoPorUnidadeAcumuladoAno",
            category: "agrupador",
            value: "valor",
            bullet: "valor",
            bulletPosition: "out",
            bulletColor: "#fff",
            lista: [...listaGraficoCustoPorUnidadeAcumuladoAno].sort((a, b) => a.valor - b.valor),
            titulo: `Custo Acumulado ${filtro.custo_ano_safra ? "Período Safra" : "Anual"} por UC (R$)`,
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoPorUnidadeAcumuladoAno(graficoCustoPorUnidadeAcumuladoAnoAtualizado);
    }

    function renderizarCelulasComZeros(corCiclo, listaDados) {
        let listaMeses = [];
        for (let i = listaDados.length; i < 12; i++) {
            listaMeses.push(i);
        }

        return listaMeses.map((mes) => (
            <Td key={mes} alignCenter color="#fff" backgroundColor={corCiclo}>
                0
            </Td>
        ));
    }

    function renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal, alignCenter = true }) {
        const janeiroAteMaio = (
            <>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "01" ? "#66bb6a" : demandaMesFinal == "01" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Janeiro
                        {ucFiltradaSazonal ? (demandaMesInicial == "01" ? " (I)" : demandaMesFinal == "01" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "02" ? "#66bb6a" : demandaMesFinal == "02" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Fevereiro
                        {ucFiltradaSazonal ? (demandaMesInicial == "02" ? " (I)" : demandaMesFinal == "02" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "03" ? "#66bb6a" : demandaMesFinal == "03" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Março
                        {ucFiltradaSazonal ? (demandaMesInicial == "03" ? " (I)" : demandaMesFinal == "03" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "04" ? "#66bb6a" : demandaMesFinal == "04" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Abril
                        {ucFiltradaSazonal ? (demandaMesInicial == "04" ? " (I)" : demandaMesFinal == "04" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "05" ? "#66bb6a" : demandaMesFinal == "05" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Maio
                        {ucFiltradaSazonal ? (demandaMesInicial == "05" ? " (I)" : demandaMesFinal == "05" ? " (F)" : "") : ""}
                    </span>
                </Th>{" "}
            </>
        );
        const junhoAteDez = (
            <>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "06" ? "#66bb6a" : demandaMesFinal == "06" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Junho
                        {ucFiltradaSazonal ? (demandaMesInicial == "06" ? " (I)" : demandaMesFinal == "06" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "07" ? "#66bb6a" : demandaMesFinal == "07" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Julho
                        {ucFiltradaSazonal ? (demandaMesInicial == "07" ? " (I)" : demandaMesFinal == "07" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "08" ? "#66bb6a" : demandaMesFinal == "08" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Agosto
                        {ucFiltradaSazonal ? (demandaMesInicial == "08" ? " (I)" : demandaMesFinal == "08" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "09" ? "#66bb6a" : demandaMesFinal == "09" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Setembro
                        {ucFiltradaSazonal ? (demandaMesInicial == "09" ? " (I)" : demandaMesFinal == "09" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "10" ? "#66bb6a" : demandaMesFinal == "10" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Outubro
                        {ucFiltradaSazonal ? (demandaMesInicial == "10" ? " (I)" : demandaMesFinal == "10" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "11" ? "#66bb6a" : demandaMesFinal == "11" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Novembro
                        {ucFiltradaSazonal ? (demandaMesInicial == "11" ? " (I)" : demandaMesFinal == "11" ? " (F)" : "") : ""}
                    </span>
                </Th>
                <Th
                    alignCenter={alignCenter}
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "12" ? "#66bb6a" : demandaMesFinal == "12" ? "#ef5350" : null) : null,
                    }}
                >
                    <span className="pl-1">
                        Dezembro
                        {ucFiltradaSazonal ? (demandaMesInicial == "12" ? " (I)" : demandaMesFinal == "12" ? " (F)" : "") : ""}
                    </span>
                </Th>
            </>
        );

        return filtro.custo_ano_safra ? (
            <>
                {junhoAteDez}
                {janeiroAteMaio}
            </>
        ) : (
            <>
                {janeiroAteMaio}
                {junhoAteDez}
            </>
        );
    }

    function bloquearScroll(e) {
        e.preventDefault();
    }

    function toggleScroll(bloquear) {
        if (bloquear) {
            document.body.style.overflowY = "hidden";
            window.addEventListener("wheel", bloquearScroll, { passive: false });
            window.addEventListener("touchmove", bloquearScroll, { passive: false });
        } else {
            document.body.style.overflowY = "auto";
            window.removeEventListener("wheel", bloquearScroll);
            window.removeEventListener("touchmove", bloquearScroll);
        }
    }

    async function handleExport({ graficosAtivos, quantidadeUCs, quantidadeUCsMensal }) {
        const ALTURA_MAX_CONTEUDO = 84;
        const MARGIN_MAXIMA = 20;
        const condicaoGraficoPaginaInteira = quantidadeUCs > 20;

        const condicao3PorPagina = quantidadeUCs <= 7;
        const graficosPorPaginaEmFuncaoDeQuantidadeUCs = condicaoGraficoPaginaInteira ? 1 : condicao3PorPagina ? 3 : 2;

        setLoading(true);
        toggleScroll(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = "0.70"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.zoom = "0.60"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1700 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarGrafico = ({ el, marginTop = 0 }) => {
            if (el) {
                el.style.fontSize = "0.8rem";
                el.style.marginTop = marginTop;
                calcularWidthGrafico({ el });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
                const titulo = el.querySelectorAll("tspan");
                titulo.forEach((el, i) => {
                    if (el.textContent.includes("Custo")) {
                        el.style.marginTop = "3rem";
                        el.style.fontSize = "1.6rem";
                        el.style.fontWeight = "bold";
                        el.setAttribute("x", el.textContent.length * 4 + "px"); // centraliza no meio do SVG
                        el.setAttribute("text-anchor", "middle");
                    }
                });
            }
        };
        const formatarTabela = ({ el, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Remove elementos que não devem ser impressos
                el.querySelectorAll(".nao-imprimir").forEach((item) => {
                    item.remove();
                });

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula, i) => {
                    if (heightCelula) {
                        celula.style.height = heightCelula;
                    }
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";
                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };
        const exibirTagOculta = ({ el, textAlign = "left", titulo = false }) => {
            if (el) {
                calcularWidthGrafico({ el, desconto: 20 });
                el.style.color = "#FFFFFF";
                el.style.fontSize = titulo ? "1.6rem" : "1rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = "0px";
                el.style.marginTop = "10px";
                el.style.padding = "5px";
                el.style.textAlign = textAlign;
            }
        };

        if (contentCardRef.current) {
            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            const graficoCustoAnual = contentCardRef.current.querySelector("#graficoCustoAnual");
            const graficoCustoMensal = contentCardRef.current.querySelector("#graficoCustoMensal");
            const tabelaCustoMensal = contentCardRef.current.querySelector("#tabelaCustoMensal");
            const tabelaProjecaoCustoMensal = contentCardRef.current.querySelector("#tabelaProjecaoCustoMensal");
            const graficoCustoJurosPorAtrasoPagamentoAnual = contentCardRef.current.querySelector("#graficoCustoJurosPorAtrasoPagamentoAnual");
            const tabelaCustoJurosPorAtrasoPagamentoAnual = contentCardRef.current.querySelector("#tabelaCustoJurosPorAtrasoPagamentoAnual");
            const graficoCustoJurosPorAtrasoPagamentoMensal = contentCardRef.current.querySelector("#graficoCustoJurosPorAtrasoPagamentoMensal");
            const periodoGraficoCustoUnidadeAnual = contentCardRef.current.querySelector("#periodoGraficoCustoUnidadeAnual");
            const graficoCustoUnidadeAnual = contentCardRef.current.querySelector("#graficoCustoUnidadeAnual");
            const graficoCustoUnidadeMensal = contentCardRef.current.querySelector("#graficoCustoUnidadeMensal");
            const tabelaCustoUnidadeMensal = contentCardRef.current.querySelector("#tabelaCustoUnidadeMensal");
            const tituloTabelaComparativa = contentCardRef.current.querySelector("#tituloTabelaComparativa");
            const tabelaComparativa = contentCardRef.current.querySelector("#tabelaComparativa");
            const periodoCustoPorUnidadeAcumuladoAno = contentCardRef.current.querySelector("#periodoCustoPorUnidadeAcumuladoAno");
            const tabelaCustoPorUnidadeAcumuladoAno = contentCardRef.current.querySelector("#tabelaCustoPorUnidadeAcumuladoAno");

            const qtdLinhasTabela = 58;

            formatarGrafico({ el: graficoCustoAnual });
            formatarGrafico({ el: graficoCustoMensal });
            formatarTabela({ el: tabelaCustoMensal });
            formatarTabela({ el: tabelaProjecaoCustoMensal });
            formatarGrafico({ el: graficoCustoJurosPorAtrasoPagamentoAnual });
            formatarTabela({ el: tabelaCustoJurosPorAtrasoPagamentoAnual });
            formatarGrafico({ el: graficoCustoJurosPorAtrasoPagamentoMensal });
            exibirTagOculta({ el: periodoGraficoCustoUnidadeAnual });
            formatarGrafico({ el: graficoCustoUnidadeAnual });
            formatarGrafico({ el: graficoCustoUnidadeMensal, marginTop: 30 });
            formatarTabela({ el: tabelaCustoUnidadeMensal, heightCelula: quantidadeUCs > 45 ? "3.1rem" : null });
            exibirTagOculta({ el: tituloTabelaComparativa, textAlign: "center", titulo: true });
            formatarTabela({ el: tabelaComparativa, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3.1rem" : null });
            exibirTagOculta({ el: periodoCustoPorUnidadeAcumuladoAno, titulo: true });
            formatarTabela({ el: tabelaCustoPorUnidadeAcumuladoAno, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3.1rem" : null });

            function calcularAlturaGraficosUC({ condicaoUltrapassaPaginas, quantidadeUCs, quantidadeLimite }) {
                const paginasOcupadasMesmoGrafico = Math.ceil(quantidadeUCs / quantidadeLimite);

                let alturaGraficosUC = ALTURA_MAX_CONTEUDO / graficosPorPaginaEmFuncaoDeQuantidadeUCs;

                if (condicaoUltrapassaPaginas) {
                    let total = 0;

                    for (let i = 0; i < paginasOcupadasMesmoGrafico; i++) {
                        //na primeira pagina soma mais 4% pra compensar a falta do rodapé
                        if (i == 0) {
                            total += ALTURA_MAX_CONTEUDO + 4;
                        } else if (i > 0 && i < paginasOcupadasMesmoGrafico - 1) {
                            //se é pagina do meia conta 100%, pq não tem cabeçalho nem rodapé
                            total += ALTURA_MAX_CONTEUDO + 16;
                        } else if (i == paginasOcupadasMesmoGrafico - 1) {
                            //na última pagina soma mais 10% pra compensar a falta do cabeçalho
                            total += ALTURA_MAX_CONTEUDO + 10;
                        }
                    }

                    alturaGraficosUC = total;
                }

                return alturaGraficosUC;
            }

            const marginGraficosUC = `${MARGIN_MAXIMA / graficosPorPaginaEmFuncaoDeQuantidadeUCs}px`;
            const alinhamentoVertical = condicaoGraficoPaginaInteira ? "flex-start" : "center";

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                    <img src="${base64Cabecalho}" width="100%" />
                </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:3%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                            <img src="${base64Rodape}" width="100%" />
                        </div>
                    </div> `;

            const condicaoGraficoCustoAnual = graficosAtivos.graficoCustoAnual && graficoCustoAnual;
            const condicaoGraficoCustoMensal = graficosAtivos.graficoCustoMensal && graficoCustoMensal && tabelaCustoMensal;
            const condicaoGraficoCustoJurosPorAtrasoPagamentoAnual =
                graficosAtivos.graficoCustoJurosPorAtrasoPagamentoAnual && graficoCustoJurosPorAtrasoPagamentoAnual && tabelaCustoJurosPorAtrasoPagamentoAnual;
            const condicaoGraficoCustoJurosPorAtrasoPagamentoMensal = graficosAtivos.graficoCustoJurosPorAtrasoPagamentoMensal && graficoCustoJurosPorAtrasoPagamentoMensal;
            const condicaoGraficoCustoUnidadeAnual = graficosAtivos.graficoCustoUnidadeAnual && periodoGraficoCustoUnidadeAnual && graficoCustoUnidadeAnual;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoCustoAnual = condicaoGraficoCustoAnual
                ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                  graficoCustoAnual.outerHTML +
                  "</div>"
                : "";

            const htmlGraficoCustoMensal = condicaoGraficoCustoMensal
                ? `<div style="width:100%; height:${exibirPrevisorCustosMensal ? "56%" : "28%"}; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                  graficoCustoMensal.outerHTML +
                  tabelaCustoMensal.outerHTML +
                  (tabelaProjecaoCustoMensal ? tabelaProjecaoCustoMensal.outerHTML : "") +
                  "</div>"
                : "";

            const htmlGraficoCustoJurosPorAtrasoPagamentoAnual = condicaoGraficoCustoJurosPorAtrasoPagamentoAnual
                ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                  graficoCustoJurosPorAtrasoPagamentoAnual.outerHTML +
                  tabelaCustoJurosPorAtrasoPagamentoAnual.outerHTML +
                  "</div>"
                : "";

            const htmlGraficoCustoJurosPorAtrasoPagamentoMensal = condicaoGraficoCustoJurosPorAtrasoPagamentoMensal
                ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                  graficoCustoJurosPorAtrasoPagamentoMensal.outerHTML +
                  "</div>"
                : "";

            const htmlGraficoCustoUnidadeAnual = condicaoGraficoCustoUnidadeAnual
                ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                  periodoGraficoCustoUnidadeAnual.outerHTML +
                  graficoCustoUnidadeAnual.outerHTML +
                  "</div>"
                : "";
            //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
            const htmlGraficoCustoUnidadeMensal =
                graficosAtivos.graficoCustoUnidadeMensal && graficoCustoUnidadeMensal && tabelaCustoUnidadeMensal
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > 45,
                          quantidadeUCs: quantidadeUCsMensal + Math.ceil(quantidadeUCsMensal / 8),
                          quantidadeLimite: 60,
                      })}%; display:flex; flex-direction:column; align-items: center; justify-content:${alinhamentoVertical}; padding-top:20px; margin-bottom:${marginGraficosUC}; background-color:#30303d">` +
                      graficoCustoUnidadeMensal.outerHTML +
                      tabelaCustoUnidadeMensal.outerHTML +
                      "</div>"
                    : "";

            const htmlTituloTabelaComparativa =
                graficosAtivos.tabelaComparativa && tituloTabelaComparativa && tabelaComparativa
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items: center; justify-content:${alinhamentoVertical}; margin-bottom:${marginGraficosUC}; background-color:#30303d">` +
                      tituloTabelaComparativa.outerHTML +
                      tabelaComparativa.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoCustoPorUnidadeAcumuladoAno =
                graficosAtivos.graficoCustoPorUnidadeAcumuladoAno && periodoCustoPorUnidadeAcumuladoAno && tabelaCustoPorUnidadeAcumuladoAno
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items: center; justify-content:${alinhamentoVertical}; margin-bottom:${marginGraficosUC}; background-color:#30303d">` +
                      periodoCustoPorUnidadeAcumuladoAno.outerHTML +
                      tabelaCustoPorUnidadeAcumuladoAno.outerHTML +
                      "</div>"
                    : "";

            //valida graficos pequenos que cabe 3 por pagina
            const graficos = [
                { h: 28, el: htmlGraficoCustoAnual },
                { h: exibirPrevisorCustosMensal ? 56 : 28, el: htmlGraficoCustoMensal },
                { h: 28, el: htmlGraficoCustoJurosPorAtrasoPagamentoAnual },
                { h: 28, el: htmlGraficoCustoJurosPorAtrasoPagamentoMensal },
                { h: 28, el: htmlGraficoCustoUnidadeAnual },
                {
                    h: calcularAlturaGraficosUC({
                        condicaoUltrapassaPaginas: quantidadeUCs > 45,
                        quantidadeUCs: quantidadeUCsMensal + Math.ceil(quantidadeUCsMensal / 8),
                        quantidadeLimite: 60,
                    }),
                    el: htmlGraficoCustoUnidadeMensal,
                },
                {
                    h: calcularAlturaGraficosUC({ condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela, quantidadeUCs, quantidadeLimite: qtdLinhasTabela }),
                    el: htmlTituloTabelaComparativa,
                },
                {
                    h: calcularAlturaGraficosUC({ condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela, quantidadeUCs, quantidadeLimite: qtdLinhasTabela }),
                    el: htmlGraficoCustoPorUnidadeAcumuladoAno,
                },
            ].filter((g) => g.el);

            if (!graficos.length) {
                setLoading(false);
                toggleScroll(false);
                return;
            }

            const listaPaginas = [];
            for (const g of graficos) {
                if (!listaPaginas.length) {
                    listaPaginas.push({
                        indice: listaPaginas.length,
                        alturaAcumulada: g.h,
                        graficos: [g.el],
                    });
                } else {
                    const ultimaPaginaIncluida = listaPaginas[listaPaginas.length - 1];
                    if (ultimaPaginaIncluida.alturaAcumulada + g.h > ALTURA_MAX_CONTEUDO) {
                        listaPaginas.push({
                            indice: listaPaginas.length,
                            alturaAcumulada: g.h,
                            graficos: [g.el],
                        });
                    } else {
                        ultimaPaginaIncluida.alturaAcumulada += g.h;
                        ultimaPaginaIncluida.graficos.push(g.el);
                    }
                }
            }
            let html = "";

            listaPaginas.forEach((pagina) => {
                html += htmlCabecalho;
                pagina.graficos.forEach((grafico) => {
                    html += grafico;
                });
                if (pagina.alturaAcumulada < ALTURA_MAX_CONTEUDO) {
                    html += `<div style="width:100%; height:${ALTURA_MAX_CONTEUDO - pagina.alturaAcumulada}%"></div>`;
                }
                html += htmlRodape;
            });

            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            toggleScroll(false);
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    function calcularAnosCusto(listaGraficoCustoAnual) {
        let anosCusto = [];
        listaGraficoCustoAnual.forEach((item) => {
            item.anos.forEach((ano) => {
                if (anosCusto.filter((itemAno) => itemAno == ano.ano).length <= 0) {
                    anosCusto.push(ano.ano);
                }
            });
        });

        anosCusto = anosCusto.sort((a, b) => parseInt(String(a).substring(0, 4)) - parseInt(String(b).substring(0, 4)));
        return anosCusto;
    }

    function calcularMedianaAndCoeficienteVariacao(anosCusto, listaGraficoCustoAnual, simulacoesPrevisorCustos = [], modoValidacaoPendencias = "seguro") {
        let ultimoAnoCustoTodosMesesCompletos = null;
        const listaGraficoCustoAnualZeroFill = {};
        const listaMesesComVariacaoValida = [[], [], [], [], [], [], [], [], [], [], [], []];
        const listaMesesComValoresValidados = [[], [], [], [], [], [], [], [], [], [], [], []];
        const simulacoesPorMes = (simulacoesPrevisorCustos || []).reduce((acc, simulacao) => {
            acc[`${simulacao.ano}-${simulacao.mes}`] = simulacao.ucs_importacao || [];
            return acc;
        }, {});
        let ultimaListaUcsImportacao = [];
        const ultimoMesCompletoPorMes = {};
        for (let i = 0; i < anosCusto.length; i++) {
            let anoCompleto = true;
            const ano = anosCusto[i];
            const primeiroMesComUcsAno =
                listaGraficoCustoAnual.find((mes) => {
                    const anoNaLista = mes.anos.find((item) => item.ano == ano) || {};
                    return (anoNaLista.ucs_importacao || []).length > 0;
                }) || {};
            const primeiroRegistroAnoComUcs = (primeiroMesComUcsAno.anos || []).find((item) => item.ano == ano) || {};
            const primeiraListaUcsImportacaoAno = primeiroRegistroAnoComUcs.ucs_importacao || [];
            listaGraficoCustoAnualZeroFill[ano] = [];
            for (const mes of listaGraficoCustoAnual) {
                const anoNaLista = mes.anos.find((item) => item.ano == ano) || {};

                const valorMesIncompleto = anoNaLista.valor == null;
                let listaUcsImportacao = anoNaLista.ucs_importacao || [];

                if (listaUcsImportacao.length > 0) {
                    ultimaListaUcsImportacao = listaUcsImportacao;
                } else if (ultimaListaUcsImportacao.length > 0) {
                    listaUcsImportacao = ultimaListaUcsImportacao.map((uc) => ({
                        ...uc,
                        importada: false,
                        valor: 0,
                    }));
                } else if (primeiraListaUcsImportacaoAno.length > 0) {
                    listaUcsImportacao = primeiraListaUcsImportacaoAno.map((uc) => ({
                        ...uc,
                        importada: false,
                        valor: 0,
                    }));
                }
                const listaUcsSimuladas = simulacoesPorMes[`${ano}-${mes.mes}`];
                if (listaUcsSimuladas) {
                    listaUcsImportacao = listaUcsImportacao.map((uc) => {
                        const ucSimulada = listaUcsSimuladas.find((itemSimulado) => itemSimulado.nome_unidade_consumidora === uc.nome_unidade_consumidora);
                        return ucSimulada ? { ...uc, ...ucSimulada } : uc;
                    });
                }
                const todasFaturasImportadas = listaUcsImportacao.length ? listaUcsImportacao.every((uc) => uc.importada) : anoNaLista.todas_faturas_importadas;
                const valorSimulado = listaUcsSimuladas ? listaUcsImportacao.reduce((total, uc) => total + (parseFloat(uc.valor) || 0), 0) : null;
                const valor = valorSimulado == null ? (valorMesIncompleto ? 0 : anoNaLista.valor) : valorSimulado;
                const custoGestaoAcl = anoNaLista.custo_gestao_acl == null ? null : anoNaLista.custo_gestao_acl;
                const contribuicaoAssociativaCcee = anoNaLista.contribuicao_associativa_ccee == null ? null : anoNaLista.contribuicao_associativa_ccee;
                const custoEnergiaAclLp = anoNaLista.custo_energia_acl_lp == null ? null : anoNaLista.custo_energia_acl_lp;
                const custoEnergiaAclCp = anoNaLista.custo_energia_acl_cp == null ? null : anoNaLista.custo_energia_acl_cp;
                const custoTotal =
                    parseFloat(valor || 0) +
                    parseFloat(custoGestaoAcl || 0) +
                    parseFloat(contribuicaoAssociativaCcee || 0) +
                    parseFloat(custoEnergiaAclLp || 0) +
                    parseFloat(custoEnergiaAclCp || 0);

                const formattedItem = {
                    ano,
                    mes: mes.mes,
                    custo_distribuicao: valor,
                    custo_gestao_acl: custoGestaoAcl,
                    contribuicao_associativa_ccee: contribuicaoAssociativaCcee,
                    custo_energia_acl_lp: custoEnergiaAclLp,
                    custo_energia_acl_cp: custoEnergiaAclCp,
                    custo_total: custoTotal,
                    todas_faturas_importadas: todasFaturasImportadas == null ? false : todasFaturasImportadas,
                    ucs_importacao: listaUcsImportacao,
                };

                const mesPossuiCustoTotal = parseFloat(formattedItem.custo_total || 0) > 0;
                const mesCompletoParaCalculo =
                    modoValidacaoPendencias === "ignorando_pendencias" ? mesPossuiCustoTotal : formattedItem.todas_faturas_importadas === true && mesPossuiCustoTotal;
                formattedItem.completo_para_calculo = mesCompletoParaCalculo;
                anoCompleto = anoCompleto && mesCompletoParaCalculo;
                formattedItem.variacao = "Indefinida";
                listaGraficoCustoAnualZeroFill[ano].push(formattedItem);
            }
            if (anoCompleto) {
                listaGraficoCustoAnualZeroFill[ano].forEach((formattedItem) => {
                    const indiceMes = Number(formattedItem.mes) - 1;
                    listaMesesComValoresValidados[indiceMes].push(formattedItem.custo_total);

                    const ultimoMesCompleto = ultimoMesCompletoPorMes[formattedItem.mes];
                    if (ultimoMesCompleto) {
                        formattedItem.variacao = variacao(ultimoMesCompleto.custo_total, formattedItem.custo_total);
                        formattedItem.ano_comparacao_variacao = ultimoMesCompleto.ano;
                        formattedItem.custo_total_comparacao_variacao = ultimoMesCompleto.custo_total;
                    }

                    if (!isNaN(formattedItem.variacao)) {
                        listaMesesComVariacaoValida[indiceMes].push(formattedItem.variacao);
                    }

                    ultimoMesCompletoPorMes[formattedItem.mes] = formattedItem;
                });
                ultimoAnoCustoTodosMesesCompletos = ano;
            }
        }

        const listaMediaPorMes = listaMesesComVariacaoValida.map((valores) => media(valores));
        const listaCoeficienteVariacaoPorMes = listaMesesComValoresValidados.map((valores) => coeficienteVariacao(valores));
        return { listaMediaPorMes, listaCoeficienteVariacaoPorMes, listaGraficoCustoAnualZeroFill, ultimoAnoCustoTodosMesesCompletos };
    }

    function getUcsImportacaoComHistorico(listaGraficoCustoAnualZeroFill, ano, mes, listaUcsImportacao) {
        return (listaUcsImportacao || []).map((uc) => {
            const historicoAnosAnteriores = getHistoricoUcMesAnosAnteriores(listaGraficoCustoAnualZeroFill, ano, mes, uc.nome_unidade_consumidora).sort(
                (itemA, itemB) => parseInt(itemA.ano) - parseInt(itemB.ano)
            );
            const valoresHistorico = historicoAnosAnteriores.map((item) => parseFloat(item.valor || 0));
            const mediaHistorico = valoresHistorico.length > 0 ? valoresHistorico.reduce((total, valor) => total + valor, 0) / valoresHistorico.length : 0;

            return {
                ...uc,
                historico_anos_anteriores: historicoAnosAnteriores,
                media_historico_anos_anteriores: mediaHistorico,
            };
        });
    }

    function getHistoricoUcMesAnosAnteriores(listaGraficoCustoAnualZeroFill, anoAtual, mes, nomeUnidadeConsumidora) {
        if (!listaGraficoCustoAnualZeroFill || !anoAtual || !mes || !nomeUnidadeConsumidora) return [];

        return Object.entries(listaGraficoCustoAnualZeroFill)
            .filter(([ano]) => parseInt(ano) < parseInt(anoAtual))
            .sort(([anoA], [anoB]) => parseInt(anoA) - parseInt(anoB))
            .map(([ano, listaMeses]) => {
                const itemMes = (listaMeses || []).find((item) => item.mes === mes);
                const itemUc = ((itemMes || {}).ucs_importacao || []).find((uc) => uc.nome_unidade_consumidora === nomeUnidadeConsumidora);

                return itemUc ? { ...itemUc, ano, mes } : null;
            })
            .filter(Boolean);
    }

    function getMesesPendentesPrevisorCustos(listaGraficoCustoAnualZeroFill) {
        if (!listaGraficoCustoAnualZeroFill) return [];

        return Object.entries(listaGraficoCustoAnualZeroFill).flatMap(([ano, listaMeses]) =>
            (listaMeses || [])
                .filter((itemMes) => itemMes.todas_faturas_importadas === false)
                .map((itemMes) => ({
                    ...itemMes,
                    ano,
                    ucs_importacao: getUcsImportacaoComHistorico(listaGraficoCustoAnualZeroFill, ano, itemMes.mes, itemMes.ucs_importacao || []),
                }))
        );
    }

    function getMesesPendentesPrevisorCustosAteMesAtual(listaMesesPendentesPrevisorCustos) {
        return (listaMesesPendentesPrevisorCustos || []).filter((itemMes) => {
            return isCompetenciaPrevisorCustosAteMesAtual(itemMes.ano, itemMes.mes);
        });
    }

    function isCompetenciaPrevisorCustosAteMesAtual(ano, mes) {
        const dataAtual = new Date();
        const competenciaAtual = dataAtual.getFullYear() * 100 + (dataAtual.getMonth() + 1);
        const anoCompetencia = getAnoCompetenciaPrevisorCustos(ano, mes);
        const competenciaMes = anoCompetencia * 100 + Number(mes);

        return competenciaMes <= competenciaAtual;
    }

    function getAnoCompetenciaPrevisorCustos(ano, mes) {
        const anosSafra = String(ano)
            .split("/")
            .map((itemAno) => Number(itemAno));

        if (anosSafra.length === 2) {
            return Number(mes) >= 6 ? anosSafra[0] : anosSafra[1];
        }

        return Number(ano);
    }

    function aplicarMediaPendentesPrevisorCustos(mesesComMediaAplicada) {
        setSimulacoesPrevisorCustos((simulacoesAtuais) => {
            const novasSimulacoes = [...(simulacoesAtuais || [])];

            (mesesComMediaAplicada || []).forEach((mesAplicado) => {
                const indiceSimulacaoExistente = novasSimulacoes.findIndex((simulacao) => simulacao.ano == mesAplicado.ano && simulacao.mes == mesAplicado.mes);
                if (indiceSimulacaoExistente >= 0) {
                    novasSimulacoes[indiceSimulacaoExistente] = mesAplicado;
                } else {
                    novasSimulacoes.push(mesAplicado);
                }
            });

            return novasSimulacoes;
        });
        setMesesPendentePrevisorCustos(null);
        setCompetenciaFocoModalPrevisorCustos(null);
    }

    function abrirModalPendenciasPrevisorCustos(competenciaFoco = null) {
        setCompetenciaFocoModalPrevisorCustos(competenciaFoco);
        setMesesPendentePrevisorCustos(listaMesesPendentesPrevisorCustosAteMesAtual.length ? listaMesesPendentesPrevisorCustosAteMesAtual : null);
    }

    function checkClientePossuiUcIrrigante() {
        return (
            listaUnidadeConsumidora.filter((ucLista) => {
                if (filtro.unidades_consumidoras.length) {
                    return filtro.unidades_consumidoras.find((uc) => uc.value == ucLista.id) && ucLista.irrigante;
                } else {
                    return (!filtro.id_cliente || filtro.id_cliente == ucLista.id_cliente) && ucLista.irrigante;
                }
            }).length > 0
        );
    }

    function getQuantidadeUcMensal() {
        return listaGraficoCustoUnidadeMensal.reduce((maximo, item) => {
            const quantidadeTipos = item.tipos.filter(
                (tipo) => !(filtro.unidades_custo_anual || []).length || (filtro.unidades_custo_anual || []).some((itemFiltro) => itemFiltro.label === tipo.tipo)
            ).length;

            return Math.max(maximo, quantidadeTipos);
        }, 0);
    }

    function obterNomesUCs(lista) {
        return lista.reduce((nomes, item) => {
            item.tipos.forEach((uc) => {
                if (!nomes.includes(uc.tipo)) {
                    nomes.push(uc.tipo);
                }
            });

            return nomes;
        }, []);
    }

    function getCustosTotaisAntesDepois() {
        return listaCustoPorUnidadePeriodo.reduce(
            (objetoTotais, elemento) => {
                objetoTotais.valor_anterior += parseFloat(elemento.valor_anterior || 0);
                objetoTotais.valor_atual += parseFloat(elemento.valor_atual || 0);
                return objetoTotais;
            },
            { valor_anterior: 0, valor_atual: 0 }
        );
    }

    function calcularComparativo(item) {
        let comparativo = parseFloat(item.valor_atual) > 0 && parseFloat(item.valor_anterior) > 0 ? (parseFloat(item.valor_atual) * 100) / parseFloat(item.valor_anterior) : 0;
        if (comparativo > 0) {
            comparativo = comparativo - 100;
        }
        return comparativo;
    }

    function getDemandaCellColor(contratoDemanda) {
        let ucFiltradaSazonal = false;
        let demandaMesInicial = "";
        let demandaMesFinal = "";
        //se é não sazonal, pega os últimos 12 meses,
        const mesAtualDate = new Date().getMonth(); //não soma 1 pq o mes atual não deve ser contabilizado
        const anoAtual = String(new Date().getFullYear());
        //AQUI É A LÓGICA PARA PINTAR AS CÉLULAS DE CINZA
        if (contratoDemanda) {
            const mesLimite = mesAtualDate < 10 ? "0" + mesAtualDate : String(mesAtualDate);
            const mesesDescontar = Number(mesLimite) - 11; //diminui 11 meses para pegar o mes inicial dos últimos 12 meses
            const anoInicialCalculado = mesesDescontar > 0 ? anoAtual : anoAtual - 1; //se descontando 11 meses der negativo, considera ano anterior
            const mesInicialCalculado = Number(mesLimite) + 1 > 12 ? "01" : Number(mesLimite) + 1; //mes atual 10, inicia em 10+1 do ano anterior
            const competenciaInicialCalculada = Number(String(anoInicialCalculado) + String(mesInicialCalculado)); //usada pra comparar com competencia base
            //se competencia base for maior considera ela como inicial, senão considera a calculada
            const competenciaBaseSazonalidade =
                contratoDemanda.competencia_base_sazonalidade > competenciaInicialCalculada ? contratoDemanda.competencia_base_sazonalidade : competenciaInicialCalculada;

            ucFiltradaSazonal = contratoDemanda.unidade_consumidora_sazonal;
            demandaMesInicial = ucFiltradaSazonal ? String(contratoDemanda.competencia_inicio).substring(4, 6) : String(competenciaBaseSazonalidade).substring(4, 6);
            demandaMesFinal = ucFiltradaSazonal ? String(contratoDemanda.competencia_fim).substring(4, 6) : mesLimite;
        }
        return { ucFiltradaSazonal, demandaMesInicial, demandaMesFinal };
    }

    const { ucFiltradaSazonal, demandaMesInicial, demandaMesFinal } = getDemandaCellColor(contratoDemanda);

    const corCiclo = "#30303d";

    const listaNomesUCs = obterNomesUCs(listaGraficoCustoUnidadeMensal);

    const listaTabelaCustoJurosPorAtrasoPagamentoAnual = graficoCustoJurosPorAtrasoPagamentoAnual ? graficoCustoJurosPorAtrasoPagamentoAnual._data : [];
    const periodoCustoJurosPorAtrasoPagamentoAnual = Object.keys(listaGraficoCustoJurosPorAtrasoPagamentoAnual[0] || {})[0];

    const quantidadeAnos = anosCusto.length;
    const quantidadeUCs = listaGraficoCustoPorUnidadeAcumuladoAno.length || 0;
    const quantidadeUCsMensal = getQuantidadeUcMensal();
    const clientePossuiUcIrrigante = checkClientePossuiUcIrrigante();
    const mesAtualZeroFill = DateFormat.getNumberMonthAsString(new Date());
    const objetoTotais = getCustosTotaisAntesDepois();

    const comparativoTotais = calcularComparativo(objetoTotais);

    return (
        <div ref={contentCardRef}>
            {listaModalFaturasSemImportacao.length > 0 && (
                <ModalAlert titulo="Faturas Não Importadas" handleClose={() => setListaModalFaturasSemImportacao([])}>
                    <ContentCardBody style={{ marginBlock: 20 }}>
                        <div className="custom-auto" style={{ borderRadius: "0.3rem", overflow: "hidden", border: "1px solid #DDD" }}>
                            <Table responsive>
                                <THead>
                                    <Th>
                                        <div className="pl-2">Unidade Consumidora</div>
                                    </Th>
                                    <Th>Competência</Th>
                                </THead>
                                <TBody>
                                    {listaModalFaturasSemImportacao.map((item, iTr) => (
                                        <NewTr noButtons backgroundColorTr={iTr % 2 == 0 ? "#DDD" : "#EEE"}>
                                            <Td>
                                                <div className="pl-2">{item.nome_unidade_consumidora}</div>
                                            </Td>
                                            <Td alignCenter width={100}>
                                                {String(item.competencia).substring(4, 6) + "/" + String(item.competencia).substring(0, 4)}
                                            </Td>
                                        </NewTr>
                                    ))}
                                </TBody>
                            </Table>
                            {usuarioLogado.administrador && (
                                <Row alignCenter style={{ paddingRight: 5 }}>
                                    <Grid cols="12 12 4 4" style={{ display: "flex", justifyContent: "center" }}>
                                        <Button
                                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 0.8rem)", whiteSpace: "nowrap" }}>Verificar</span>}
                                            title="Verificar"
                                            type={"primary"}
                                            icon={"fa fa-search"}
                                            event={() => {
                                                const { history } = props;
                                                setListaFaturasRedirecionamento(listaModalFaturasSemImportacao);
                                                history.push("/fatura");
                                            }}
                                        />
                                    </Grid>
                                </Row>
                            )}
                        </div>
                    </ContentCardBody>
                </ModalAlert>
            )}
            {mesesPendentePrevisorCustos && mesesPendentePrevisorCustos.length > 0 && (
                <ModalSimularFaturaPendentePrevisorCustos
                    mesesPendentePrevisorCustos={mesesPendentePrevisorCustos}
                    competenciaFoco={competenciaFocoModalPrevisorCustos}
                    onAplicarMediaPendentes={aplicarMediaPendentesPrevisorCustos}
                    handleClose={() => {
                        setMesesPendentePrevisorCustos(null);
                        setCompetenciaFocoModalPrevisorCustos(null);
                    }}
                />
            )}
            {mensagemModalPrevisorCustos ? (
                <ModalSelecionarModoPrevisorCustos
                    titulo={mensagemModalPrevisorCustos.titulo}
                    mensagem={mensagemModalPrevisorCustos.mensagem}
                    handleClose={() => setMensagemModalPrevisorCustos(null)}
                />
            ) : null}
            {loading ? (
                <>
                    <Loading />
                    <div style={{ height: "100vh", width: "100%" }}></div>
                </>
            ) : null}
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)} visibility={loading ? "hidden" : "visible"}>
                            <ExportAnalise quantidadeAnos={quantidadeAnos} quantidadeUCs={quantidadeUCs} />
                        </ModalAlert>
                    ) : null}
                    <div
                        id="graficoCustoAnual"
                        style={{
                            width: "100%",
                            minWidth: "890px",
                            height: "400px",
                        }}
                    ></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                    <div
                        id="graficoCustoMensal"
                        style={{
                            width: "100%",
                            minWidth: "890px",
                            height: "400px",
                        }}
                    ></div>
                    {exibirTabelaCustoMensal && (
                        <div style={{ minWidth: "890px" }}>
                            <Row>
                                <Grid cols="12 12 4 4" style={{ paddingTop: 10, display: "flex", alignItems: "center" }}>
                                    <Button
                                        text={exibirPrevisorCustosMensal ? "Ocultar Previsor de Custos" : "Exibir Previsor de Custos"}
                                        type={exibirPrevisorCustosMensal ? "danger" : "primary"}
                                        icon={"fas fa-table"}
                                        event={() => {
                                            if (exibirPrevisorCustosMensal) {
                                                setExibirPrevisorCustosMensal(false);
                                                setProjecoesPrevisorCustos([]);
                                                setMensagemModalPrevisorCustos(null);
                                                return;
                                            }
                                            abrirPrevisorCustosMensalAutomatico();
                                        }}
                                    />
                                </Grid>
                                {listaMesesPendentesPrevisorCustosAteMesAtual.length > 0 ? (
                                    <Grid cols="12 12 7 7" style={{ paddingTop: 10, display: "flex", alignItems: "center" }}>
                                        <Button
                                            forceBorder={true}
                                            hoverStyle={pendenciasPrevisorCustosEditaveis ? { filter: "brightness(1.1)" } : null}
                                            style={{
                                                width: "fit-content",
                                                padding: "0px 8px",
                                                backgroundColor: "#161920",
                                                color: "#ffb02e",
                                                fontWeight: 500,
                                                border: pendenciasPrevisorCustosEditaveis ? "1px solid #ffb02e" : "1px solid transparent",
                                                cursor: pendenciasPrevisorCustosEditaveis ? "pointer" : "default",
                                            }}
                                            text={
                                                <div className="d-flex p-2">
                                                    <AlertIcon width={15} height={15} title={""} animationClass={"alerta-triangulo-visualizado"} />
                                                    <span style={{ paddingLeft: 4 }}>
                                                        {pendenciasPrevisorCustosEditaveis
                                                            ? "Existem faturas pendentes. Clique aqui para preencher opcionalmente"
                                                            : "Existem faturas pendentes."}
                                                    </span>
                                                </div>
                                            }
                                            title="Preencher valores pendentes opcionalmente"
                                            event={pendenciasPrevisorCustosEditaveis ? () => abrirModalPendenciasPrevisorCustos() : undefined}
                                        />
                                    </Grid>
                                ) : null}
                            </Row>
                            <Table maxHeight="100vh" responsive id="tabelaCustoMensal">
                                <THead>
                                    <Tr>
                                        <Th alignCenter={true}>Ano</Th>
                                        {ucsMercadoLivre.length > 0 && detalharCustosMercadoLivre && <Th>Custo Detalhado</Th>}
                                        {renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal, alignCenter: false })}
                                    </Tr>
                                </THead>
                                <TBody>
                                    {anosCusto.map((ano, indice, lista) => {
                                        const mesesAnoPrevisor = listaGraficoCustoAnualZeroFill[ano] || [];
                                        const anoCompletoParaPrevisor = mesesAnoPrevisor.length > 0 && mesesAnoPrevisor.every((itemMes) => itemMes.completo_para_calculo === true);
                                        const corLinhaAnoPrevisor = anoCompletoParaPrevisor ? "#14a498" : "transparent";
                                        return (
                                            <Tr key={ano} style={{ backgroundColor: corLinhaAnoPrevisor }}>
                                                <Td width={100} alignCenter color="#FFF" backgroundColor={"#18688c"} fontSize="0.72rem" fontWeight="bold">
                                                    <b>{ano}</b>
                                                    {exibirPrevisorCustosMensal ? (
                                                        <TextInPill color="#222" background="#e2e2e2" text="Variação D %" style={{ marginBottom: 6 }} />
                                                    ) : null}
                                                    {ucsMercadoLivre.length > 0 ? (
                                                        detalharCustosMercadoLivre == ano ? (
                                                            <Button
                                                                style={{ width: 140, padding: 2 }}
                                                                text={<span style={{ fontSize: "0.8rem" }}>Ocultar Custos M.L.</span>}
                                                                solid={true}
                                                                type="danger"
                                                                event={() => setDetalharCustosMercadoLivre(null)}
                                                            />
                                                        ) : (
                                                            <Button
                                                                style={{ width: 140, padding: 2 }}
                                                                text={<span style={{ fontSize: "0.8rem" }}>Detalhar Custos M.L.</span>}
                                                                type="info"
                                                                solid={true}
                                                                event={() => setDetalharCustosMercadoLivre(ano)}
                                                            />
                                                        )
                                                    ) : null}
                                                </Td>
                                                {ucsMercadoLivre.length > 0 ? (
                                                    detalharCustosMercadoLivre === ano ? (
                                                        <Td color="#fff" padding={0} fontSize="0.72rem" backgroundColor={corLinhaAnoPrevisor}>
                                                            <Table style={{ width: "100%" }}>
                                                                <TBody>
                                                                    <Tr>
                                                                        <Td color="#FFF" borderTop="none">
                                                                            Custo En. ACL CP.
                                                                        </Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF">Custo En. ACL LP.</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF">Contrib Assoc.</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF">Custo Gestão</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF" borderBottom="none">
                                                                            Custo Distrib.
                                                                        </Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF" borderBottom="none" backgroundColor="#1484fe">
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    height: exibirPrevisorCustosMensal ? 42 : "fit-content",
                                                                                }}
                                                                            >
                                                                                Total
                                                                            </div>
                                                                        </Td>
                                                                    </Tr>
                                                                </TBody>
                                                            </Table>
                                                        </Td>
                                                    ) : detalharCustosMercadoLivre != null ? (
                                                        <Td backgroundColor={corLinhaAnoPrevisor}></Td>
                                                    ) : null
                                                ) : null}

                                                {mesesAnoPrevisor.map((itemMes, indiceMes, lista) => {
                                                    const exibirAlertaFaturaPendente =
                                                        !itemMes.todas_faturas_importadas && isCompetenciaPrevisorCustosAteMesAtual(ano, itemMes.mes);
                                                    const percentualVariacao = parseFloat(itemMes.variacao);
                                                    const variacaoIndefinida = isNaN(percentualVariacao) || indice == 0;
                                                    const variacaoPossivelIrregularidade = !variacaoIndefinida && Math.abs(percentualVariacao) >= 1;
                                                    const custoTotalMes = (
                                                        <>
                                                            <div
                                                                className="d-flex"
                                                                style={{
                                                                    cursor: exibirAlertaFaturaPendente && pendenciasPrevisorCustosEditaveis ? "pointer" : "default",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                {exibirAlertaFaturaPendente ? (
                                                                    <AlertIcon
                                                                        width={15}
                                                                        height={15}
                                                                        title={[...(itemMes.ucs_importacao || [])]
                                                                            .filter((uc) => !uc.importada)
                                                                            .map((uc) => uc.nome_unidade_consumidora + ": " + (uc.importada ? "Importada" : "Pendente"))
                                                                            .join("\n")}
                                                                        animationClass={"alerta-triangulo-visualizado"}
                                                                        event={
                                                                            pendenciasPrevisorCustosEditaveis
                                                                                ? () => abrirModalPendenciasPrevisorCustos({ ano, mes: itemMes.mes })
                                                                                : undefined
                                                                        }
                                                                    />
                                                                ) : null}
                                                                <span className="pl-1">{`R$ ${adicionarPontosMilhar(parseFloat(itemMes.custo_total || 0))}`}</span>
                                                            </div>
                                                            {exibirPrevisorCustosMensal ? (
                                                                <TextInPill
                                                                    title={
                                                                        variacaoIndefinida ||
                                                                        itemMes.custo_total_comparacao_variacao === null ||
                                                                        itemMes.custo_total_comparacao_variacao === undefined
                                                                            ? null
                                                                            : `1 - (${adicionarPontosMilhar(
                                                                                  parseFloat(itemMes.custo_total_comparacao_variacao || 0)
                                                                              )} / ${adicionarPontosMilhar(parseFloat(itemMes.custo_total || 0))})`
                                                                    }
                                                                    style={{ marginBottom: 6, textAlign: variacaoIndefinida ? "center" : "left" }}
                                                                    color={variacaoIndefinida ? "#222" : itemMes.variacao < 0 ? "#00952a" : "#e70101"}
                                                                    background={variacaoPossivelIrregularidade ? "#fff700" : "#e2e2e2"}
                                                                    text={variacaoIndefinida ? itemMes.variacao : `${adicionarPontosMilhar(percentualVariacao * 100)}%`}
                                                                />
                                                            ) : null}
                                                        </>
                                                    );
                                                    return ucsMercadoLivre.length && detalharCustosMercadoLivre === ano ? (
                                                        <Td key={ano + "-" + itemMes.mes} color="#fff" padding={0} fontSize="0.72rem" backgroundColor={corLinhaAnoPrevisor}>
                                                            <Table style={{ width: "100%" }}>
                                                                <TBody>
                                                                    <Tr>
                                                                        <Td color="#FFF" borderTop="none">{`R$ ${adicionarPontosMilhar(
                                                                            parseFloat(itemMes.custo_energia_acl_cp || 0)
                                                                        )}`}</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF">{`R$ ${adicionarPontosMilhar(parseFloat(itemMes.custo_energia_acl_lp || 0))}`}</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF">{`R$ ${adicionarPontosMilhar(parseFloat(itemMes.contribuicao_associativa_ccee || 0))}`}</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF">{`R$ ${adicionarPontosMilhar(parseFloat(itemMes.custo_gestao_acl || 0))}`}</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF">{`R$ ${adicionarPontosMilhar(parseFloat(itemMes.custo_distribuicao || 0))}`}</Td>
                                                                    </Tr>
                                                                    <Tr>
                                                                        <Td color="#FFF" backgroundColor="#1484fe" borderBottom="none">
                                                                            {custoTotalMes}
                                                                        </Td>
                                                                    </Tr>
                                                                </TBody>
                                                            </Table>
                                                        </Td>
                                                    ) : (
                                                        <Td key={ano + "-" + itemMes.mes} color="#fff" fontSize="0.72rem" backgroundColor={corLinhaAnoPrevisor}>
                                                            {custoTotalMes}
                                                        </Td>
                                                    );
                                                })}
                                            </Tr>
                                        );
                                    })}
                                    {exibirPrevisorCustosMensal ? (
                                        <>
                                            <Tr>
                                                <Td fontSize="0.72rem" alignCenter color="#FFF" backgroundColor="#3e5972" fontWeight="bolder">
                                                    <TextInPill
                                                        color="#19616c"
                                                        background="#69ffd4"
                                                        text={
                                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                <div>Variação</div>
                                                                <div>Média D %</div>
                                                            </div>
                                                        }
                                                    />
                                                </Td>
                                                {ucsMercadoLivre.length > 0 && detalharCustosMercadoLivre && <Th></Th>}
                                                {listaMediaPorMes.map((media) => {
                                                    const mediaPossivelIrregularidade = !isNaN(parseFloat(media)) && Math.abs(parseFloat(media)) >= 1;
                                                    return (
                                                        <Td color="#FFF">
                                                            <TextInPill
                                                                color={media < 0 ? "#04652a" : media >= 0 ? "#ff2121" : "#FFF"}
                                                                background={mediaPossivelIrregularidade ? "#fff700" : "#69ffd4"}
                                                                text={`${adicionarPontosMilhar(media * 100)}%`}
                                                            />
                                                        </Td>
                                                    );
                                                })}
                                            </Tr>
                                            <Tr>
                                                <Td fontSize="0.72rem" alignCenter color="#FFF" backgroundColor="#3e5972" fontWeight="bolder">
                                                    <TextInPill color="#FFF" background="#0090f0" text="Coeficiênte de Variação (%)" />
                                                </Td>
                                                {ucsMercadoLivre.length > 0 && detalharCustosMercadoLivre && <Th></Th>}
                                                {listaCoeficienteVariacaoPorMes.map((cv) => {
                                                    const coeficienteVariacaoPossivelIrregularidade = !isNaN(parseFloat(cv)) && Math.abs(parseFloat(cv)) >= 1;
                                                    return (
                                                        <Td color="#FFF">
                                                            <TextInPill
                                                                color={coeficienteVariacaoPossivelIrregularidade ? "#222" : "#FFF"}
                                                                background={coeficienteVariacaoPossivelIrregularidade ? "#fff700" : "#0090f0"}
                                                                text={`${adicionarPontosMilhar(cv * 100)}%`}
                                                            />
                                                        </Td>
                                                    );
                                                })}
                                            </Tr>
                                        </>
                                    ) : null}
                                </TBody>
                            </Table>
                            <TabelaPrevisorCustos
                                exibirPrevisorCustosMensal={exibirPrevisorCustosMensal}
                                listaMediaPorMes={listaMediaPorMes}
                                listaCoeficienteVariacaoPorMes={listaCoeficienteVariacaoPorMes}
                                listaCustoMesesAno={listaGraficoCustoAnualZeroFill}
                                ultimoAnoCompleto={ultimoAnoCustoTodosMesesCompletos}
                                projecoes={projecoesPrevisorCustos}
                                callback={(projecoes) => {
                                    setProjecoesPrevisorCustos(projecoes);
                                    atualizarListaGraficoCustoAnual({ projecaoMensal: projecoes });
                                }}
                            />
                        </div>
                    )}
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div
                        id="graficoCustoJurosPorAtrasoPagamentoAnual"
                        style={{
                            width: "100%",
                            minWidth: "890px",
                            height: "400px",
                        }}
                    ></div>
                </ContentCardBody>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                    <div style={{ minWidth: "890px" }}>
                        <Table responsive id="tabelaCustoJurosPorAtrasoPagamentoAnual">
                            <THead>
                                <Tr>
                                    <Th width={250}></Th>
                                    {listaTabelaCustoJurosPorAtrasoPagamentoAnual.map((item) => (
                                        <Th alignCenter>{item[periodoCustoJurosPorAtrasoPagamentoAnual]}</Th>
                                    ))}
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr>
                                    <Td color="#fff">R$ Total</Td>
                                    {listaTabelaCustoJurosPorAtrasoPagamentoAnual.map((item) => (
                                        <Td key={item[periodoCustoJurosPorAtrasoPagamentoAnual]} alignCenter color="#fff">
                                            {parseFloat(item.valor_fatura || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr>
                                    <Td color="#fff">R$ Juros por Atraso de Pagamento</Td>
                                    {listaTabelaCustoJurosPorAtrasoPagamentoAnual.map((item) => (
                                        <Td key={item[periodoCustoJurosPorAtrasoPagamentoAnual]} alignCenter color="#fff">
                                            {parseFloat(item.valor || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr>
                                    <Td color="#fff">Rel. %</Td>
                                    {listaTabelaCustoJurosPorAtrasoPagamentoAnual.map((item) => (
                                        <Td key={item[periodoCustoJurosPorAtrasoPagamentoAnual]} alignCenter color="#fff">
                                            {parseFloat(item.valor_fatura > 0 ? (item.valor * 100) / item.valor_fatura : 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                            %
                                        </Td>
                                    ))}
                                </Tr>
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div
                        id="graficoCustoJurosPorAtrasoPagamentoMensal"
                        style={{
                            width: "100%",
                            minWidth: "890px",
                            height: "400px",
                        }}
                    ></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardHeader style={{}}>
                    <Row>
                        <Select
                            options={listaUnidadeConsumidora.filter((item) => !filtro.id_cliente || item.id_cliente == filtro.id_cliente)}
                            label="Unidades Consumidoras"
                            cols="12 12 12 12"
                            placeholder="Selecione as UCs"
                            isMulti={true}
                            value={filtro.unidades_custo_anual}
                            onChange={(value) => {
                                setFiltro({
                                    ...filtro,
                                    unidades_custo_anual: value,
                                });
                            }}
                        />
                        {clientePossuiUcIrrigante && (
                            <Select
                                options={[
                                    { id: "Padrão", valor: "Padrão" },
                                    { id: "Período Milho", valor: "Período Milho" },
                                    { id: "Período Soja Safra", valor: "Período Soja Safra" },
                                    { id: "Período Soja Safrinha ou Milho Safrinha", valor: "Período Soja Safrinha ou Milho Safrinha" },
                                ]}
                                label="Tipo de Período Selecionável"
                                cols="12 12 4 4"
                                placeholder="Selecione as UCs"
                                isMulti={false}
                                isClearable={false}
                                value={filtro.tipo_periodo}
                                onChange={(value) => {
                                    let competencia_inicial_unidade_custo = null;
                                    let competencia_final_unidade_custo = null;

                                    switch (value) {
                                        case "Período Milho":
                                            //08 à 12
                                            competencia_inicial_unidade_custo = parseInt(
                                                `${Number(mesAtualZeroFill) < 8 ? new Date().getFullYear() - 1 : new Date().getFullYear()}08`
                                            );
                                            competencia_final_unidade_custo = parseInt(
                                                `${Number(mesAtualZeroFill) < 8 ? new Date().getFullYear() - 1 : new Date().getFullYear()}12`
                                            );
                                            break;

                                        case "Período Soja Safra":
                                            //11 à 05
                                            competencia_inicial_unidade_custo = parseInt(
                                                `${Number(mesAtualZeroFill) < 11 ? new Date().getFullYear() - 1 : new Date().getFullYear()}11`
                                            );
                                            competencia_final_unidade_custo = parseInt(
                                                `${(Number(mesAtualZeroFill) < 11 ? new Date().getFullYear() - 1 : new Date().getFullYear()) + 1}05`
                                            );
                                            break;

                                        case "Período Soja Safrinha ou Milho Safrinha":
                                            //01 à 05
                                            competencia_inicial_unidade_custo = parseInt(`${new Date().getFullYear()}01`);
                                            competencia_final_unidade_custo = parseInt(`${new Date().getFullYear()}05`);
                                            break;

                                        default:
                                            //01 à mesAtual
                                            competencia_inicial_unidade_custo = parseInt(`${new Date().getFullYear()}01`);
                                            competencia_final_unidade_custo = parseInt(`${new Date().getFullYear()}${mesAtualZeroFill}`);
                                            break;
                                    }
                                    setFiltro({
                                        ...filtro,
                                        tipo_periodo: value,
                                        competencia_inicial_unidade_custo,
                                        competencia_final_unidade_custo,
                                    });
                                }}
                            />
                        )}
                        <Grid cols="6 4 3 2" style={{ display: "flex", alignItems: "center" }}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="De"
                                    autoOk
                                    value={
                                        filtro.competencia_inicial_unidade_custo
                                            ? `${String(filtro.competencia_inicial_unidade_custo).substring(0, 4)}/${String(filtro.competencia_inicial_unidade_custo).substring(
                                                  4,
                                                  6
                                              )}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        const novoValor = parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`);
                                        setFiltro({
                                            ...filtro,
                                            tipo_periodo: filtro.competencia_inicial_unidade_custo !== novoValor ? "Padrão" : filtro.tipo_periodo,
                                            competencia_inicial_unidade_custo: value ? novoValor : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="6 4 3 2" style={{ display: "flex", alignItems: "center" }}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="Até"
                                    autoOk
                                    value={
                                        filtro.competencia_final_unidade_custo
                                            ? `${String(filtro.competencia_final_unidade_custo).substring(0, 4)}/${String(filtro.competencia_final_unidade_custo).substring(
                                                  4,
                                                  6
                                              )}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        const novoValor = parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`);
                                        setFiltro({
                                            ...filtro,
                                            tipo_periodo: filtro.competencia_final_unidade_custo !== novoValor ? "Padrão" : filtro.tipo_periodo,
                                            competencia_final_unidade_custo: value ? novoValor : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="6 4 3 2" style={{ paddingTop: 10, display: "flex", alignItems: "center" }}>
                            <Button
                                text="Limpar Período"
                                type={"primary"}
                                icon={"fa fa-minus"}
                                event={async () => {
                                    setFiltro({
                                        ...filtro,
                                        tipo_periodo: "Padrão",
                                        competencia_inicial_unidade_custo: null,
                                        competencia_final_unidade_custo: null,
                                    });
                                }}
                            />
                        </Grid>
                        <Grid cols="6 4 3 2" style={{ paddingTop: 10, display: "flex", alignItems: "center" }}>
                            <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={listar} />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        color: "#fff",
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="periodoGraficoCustoUnidadeAnual" style={{ visibility: "hidden" }}>
                        De {String(filtro.competencia_inicial_unidade_custo).substring(4, 6)}/{String(filtro.competencia_inicial_unidade_custo).substring(0, 4)} até{" "}
                        {String(filtro.competencia_final_unidade_custo).substring(4, 6)}/{String(filtro.competencia_final_unidade_custo).substring(0, 4)}
                    </div>
                    <div id="graficoCustoUnidadeAnual" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                        color: "#fff",
                    }}
                >
                    <div
                        id="graficoCustoUnidadeMensal"
                        style={{
                            width: "100%",
                            minWidth: "890px",
                            height: (listaNomesUCs || []).length > 60 ? 800 : (listaNomesUCs || []).length > 25 ? 600 : 400,
                        }}
                    ></div>{" "}
                    <div style={{ minWidth: "890px" }}>
                        <Table responsive id="tabelaCustoUnidadeMensal">
                            <THead>
                                <Tr>
                                    <Th minWidth={200}>UC</Th>
                                    {renderizarCabecalhoMeses({})}
                                </Tr>
                            </THead>
                            <TBody>
                                {listaNomesUCs
                                    .sort((a, b) => a - b)
                                    .filter(
                                        (nomeUc) =>
                                            !(filtro.unidades_custo_anual || []).length || (filtro.unidades_custo_anual || []).find((itemFiltro) => itemFiltro.label == nomeUc)
                                    )
                                    .map((nomeUc) => (
                                        <Tr key={nomeUc}>
                                            <Td color="#fff" minWidth="30vw">
                                                <div title={nomeUc}>{nomeUc}</div>
                                            </Td>
                                            {listaGraficoCustoUnidadeMensal.map((mes) => {
                                                if (mes.tipos.find((tipoMes) => tipoMes.tipo == nomeUc)) {
                                                    return mes.tipos
                                                        .filter((tipoMes) => tipoMes.tipo == nomeUc)
                                                        .map((tipoMes) => {
                                                            return (
                                                                <Td key={tipoMes.tipo} alignCenter color="#fff">
                                                                    {parseFloat(tipoMes.valor || 0)
                                                                        .toFixed(2)
                                                                        .replace(".", ",")}
                                                                </Td>
                                                            );
                                                        });
                                                } else {
                                                    return (
                                                        <Td key={nomeUc} alignCenter color="#fff">
                                                            0,00
                                                        </Td>
                                                    );
                                                }
                                            })}
                                            {renderizarCelulasComZeros(corCiclo, listaGraficoCustoUnidadeMensal)}
                                        </Tr>
                                    ))}
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="12 6 5 5">
                            <Row>
                                <Grid cols="12 12 12 12">
                                    <label>Período A</label>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="De"
                                            autoOk
                                            value={
                                                filtro.competencia_inicial_custo_comparativo_antes
                                                    ? `${String(filtro.competencia_inicial_custo_comparativo_antes).substring(0, 4)}/${String(
                                                          filtro.competencia_inicial_custo_comparativo_antes
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_inicial_custo_comparativo_antes: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="Até"
                                            autoOk
                                            value={
                                                filtro.competencia_final_custo_comparativo_antes
                                                    ? `${String(filtro.competencia_final_custo_comparativo_antes).substring(0, 4)}/${String(
                                                          filtro.competencia_final_custo_comparativo_antes
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_final_custo_comparativo_antes: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Row>
                        </Grid>
                        <Grid cols="12 6 5 5">
                            <Row>
                                <Grid cols="12 12 12 12">
                                    <label>Período B</label>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="De"
                                            autoOk
                                            value={
                                                filtro.competencia_inicial_custo_comparativo_depois
                                                    ? `${String(filtro.competencia_inicial_custo_comparativo_depois).substring(0, 4)}/${String(
                                                          filtro.competencia_inicial_custo_comparativo_depois
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_inicial_custo_comparativo_depois: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="Até"
                                            autoOk
                                            value={
                                                filtro.competencia_final_custo_comparativo_depois
                                                    ? `${String(filtro.competencia_final_custo_comparativo_depois).substring(0, 4)}/${String(
                                                          filtro.competencia_final_custo_comparativo_depois
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_final_custo_comparativo_depois: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Row>
                        </Grid>

                        <Grid cols="12 12 2 2" style={{ paddingTop: 10 }}>
                            <Button
                                text="Analisar"
                                type={"primary"}
                                icon={"fa fa-sync"}
                                event={() => {
                                    listar();
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        color: "#fff",
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <p id="tituloTabelaComparativa" className="text-center" style={{ fontSize: 16 }}>
                        Tabela Comparativa para Diferentes Períodos (R$)
                    </p>
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <Table responsive id="tabelaComparativa">
                            <THead>
                                <Tr>
                                    <Th>Unidade</Th>
                                    <Th alignCenter>
                                        {filtro.competencia_inicial_custo_comparativo_antes && filtro.competencia_final_custo_comparativo_antes
                                            ? `De ${String(filtro.competencia_inicial_custo_comparativo_antes).substring(4, 6)}/${String(
                                                  filtro.competencia_inicial_custo_comparativo_antes
                                              ).substring(0, 4)} até ${String(filtro.competencia_final_custo_comparativo_antes).substring(4, 6)}/${String(
                                                  filtro.competencia_final_custo_comparativo_antes
                                              ).substring(0, 4)}`
                                            : ""}
                                    </Th>
                                    {!modalExportacaoAberto && <Th></Th>}
                                    <Th alignCenter>Comparativo</Th>
                                    <Th alignCenter>
                                        {filtro.competencia_inicial_custo_comparativo_depois && filtro.competencia_final_custo_comparativo_depois
                                            ? `De ${String(filtro.competencia_inicial_custo_comparativo_depois).substring(4, 6)}/${String(
                                                  filtro.competencia_inicial_custo_comparativo_depois
                                              ).substring(0, 4)} até ${String(filtro.competencia_final_custo_comparativo_depois).substring(4, 6)}/${String(
                                                  filtro.competencia_final_custo_comparativo_depois
                                              ).substring(0, 4)}`
                                            : ""}
                                    </Th>
                                    {!modalExportacaoAberto && <Th></Th>}
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr style={{ minHeight: 30 }} key={"Todas Unidades"}>
                                    <Td color="#fff" backgroundColor="#257bfb">
                                        <b>Todas Unidades</b>
                                    </Td>
                                    <Td alignCenter color="#fff" backgroundColor="#257bfb">
                                        <b>R$ {adicionarPontosMilhar(parseFloat(objetoTotais.valor_anterior || 0).toFixed(2))}</b>
                                    </Td>
                                    {!modalExportacaoAberto && <Td backgroundColor="#257bfb"></Td>}
                                    <Td alignCenter color="#fff" backgroundColor={comparativoTotais == 0 ? "#257bfb" : comparativoTotais > 0 ? "#ef5350" : "#28a745"}>
                                        <b>{parseFloat(objetoTotais.valor_atual) == 0 ? `100,00` : comparativoTotais.toFixed(2).replace(".", ",")}%</b>
                                    </Td>
                                    <Td alignCenter color="#fff" backgroundColor="#257bfb">
                                        <b>R$ {adicionarPontosMilhar(parseFloat(objetoTotais.valor_atual || 0).toFixed(2))}</b>
                                    </Td>
                                    {!modalExportacaoAberto && <Td backgroundColor="#257bfb"> </Td>}
                                </Tr>
                                {listaCustoPorUnidadePeriodo.map((item, i) => {
                                    const comparativo = calcularComparativo(item);

                                    return (
                                        <Tr style={{ minHeight: 30 }} key={item.nome_unidade_consumidora}>
                                            <Td color="#fff">{item.nome_unidade_consumidora}</Td>
                                            <Td alignCenter color="#fff">
                                                R$ {adicionarPontosMilhar(parseFloat(item.valor_anterior || 0).toFixed(2))}
                                            </Td>
                                            {!modalExportacaoAberto && (
                                                <Td>
                                                    {item.faturas_anteriores_nao_importadas.length > 0 && (
                                                        <Button
                                                            hoverStyle={{ filter: "brightness(1.1)" }}
                                                            style={{
                                                                width: "fit-content",
                                                                padding: "0px 8px",
                                                                backgroundColor: "#161920",
                                                                color: "#ff3131",
                                                                fontWeight: 500,
                                                            }}
                                                            text={
                                                                <div style={{ display: "flex" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    <span style={{ margin: "6px 0 0 6px" }}>Verificar</span>
                                                                </div>
                                                            }
                                                            title="Faltam faturas no período selecionado"
                                                            event={() => {
                                                                setListaModalFaturasSemImportacao(item.faturas_anteriores_nao_importadas);
                                                            }}
                                                        />
                                                    )}
                                                </Td>
                                            )}
                                            <Td alignCenter color="#fff" backgroundColor={comparativo == 0 ? null : comparativo > 0 ? "#ef5350" : "#28a745"}>
                                                {parseFloat(item.valor_atual) == 0 ? `100,00` : comparativo.toFixed(2).replace(".", ",")}%
                                            </Td>
                                            <Td alignCenter color="#fff">
                                                R$ {adicionarPontosMilhar(parseFloat(item.valor_atual || 0).toFixed(2))}
                                            </Td>
                                            {!modalExportacaoAberto && (
                                                <Td>
                                                    {item.faturas_atuais_nao_importadas.length > 0 && (
                                                        <Button
                                                            hoverStyle={{ filter: "brightness(1.1)" }}
                                                            style={{
                                                                width: "fit-content",
                                                                padding: "0px 8px",
                                                                backgroundColor: "#161920",
                                                                color: "#ff3131",
                                                                fontWeight: 500,
                                                            }}
                                                            text={
                                                                <div style={{ display: "flex" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    <span style={{ margin: "6px 0 0 6px" }}>Verificar</span>
                                                                </div>
                                                            }
                                                            title="Faltam faturas no período selecionado"
                                                            event={() => {
                                                                setListaModalFaturasSemImportacao(item.faturas_atuais_nao_importadas);
                                                            }}
                                                        />
                                                    )}
                                                </Td>
                                            )}
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardHeader>
                    <Select
                        name="ano"
                        options={listaAnos}
                        label="Ano"
                        cols="12 6 3"
                        placeholder="Selecione o ano"
                        value={filtro.ano_acumulado_custo}
                        isClearable={false}
                        isSearchable={false}
                        onChange={(value) => {
                            setFiltro({
                                ...filtro,
                                ano_acumulado_custo: value,
                            });
                            listar();
                        }}
                    />
                </ContentCardHeader>

                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", maxHeight: 400 }}>
                    <div id="periodoCustoPorUnidadeAcumuladoAno" style={{ visibility: "hidden", display: "flex", justifyContent: "center" }}>
                        <h4>{`Custo Acumulado por UC em ${filtro.ano_acumulado_custo} (R$)`}</h4>
                    </div>
                    {modalExportacaoAberto && (
                        <Table
                            responsive
                            id="tabelaCustoPorUnidadeAcumuladoAno"
                            height={(listaGraficoCustoPorUnidadeAcumuladoAno || []).length * 50 < 400 ? 400 : listaGraficoCustoPorUnidadeAcumuladoAno.length * 50}
                        >
                            <THead>
                                <Tr>
                                    <Th>Unidade</Th>
                                    <Th></Th>
                                    <Th alignCenter>Valor (R$)</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {[...listaGraficoCustoPorUnidadeAcumuladoAno]
                                    .sort((a, b) => b.valor - a.valor)
                                    .map((item) => {
                                        const max = listaGraficoCustoPorUnidadeAcumuladoAno.reduce((acc, atual) => Math.max(acc, atual.valor || 0), 0); //o max é o valor do primeiro, que é o maior
                                        const barraPercentual = max > 0 ? (parseFloat(item.valor || 0) / max) * 100 : 0;

                                        // Intervalos de hue possíveis (neon azul/roxo/lilás + verde/amarelo fosforescente)
                                        const hueRanges = [
                                            [200, 300], // azul → roxo → lilás
                                            [70, 110], // verde-limão / amarelo-esverdeado fluorescente
                                        ];

                                        // Escolhe aleatoriamente um dos intervalos
                                        const [minHue, maxHue] = hueRanges[Math.floor(Math.random() * hueRanges.length)];
                                        const hue = minHue + Math.floor(Math.random() * (maxHue - minHue));

                                        const saturation = 90 + Math.floor(Math.random() * 10); // 90–100%
                                        const lightness = 60 + Math.floor(Math.random() * 20); // 60–80%

                                        const cor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

                                        return (
                                            <Tr key={item.agrupador}>
                                                <Td color="#fff">{item.agrupador}</Td>
                                                <Td width="40vw">
                                                    <div style={{ backgroundColor: cor, width: barraPercentual + "%", padding: 0 }}></div>
                                                </Td>
                                                <Td alignCenter color="#fff">
                                                    R$ {adicionarPontosMilhar(parseFloat(item.valor || 0).toFixed(2))}
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                            </TBody>
                        </Table>
                    )}
                    {!modalExportacaoAberto && (
                        <div
                            id="graficoCustoPorUnidadeAcumuladoAno"
                            style={{
                                width: "100%",
                                minWidth: 900,
                                height: (listaGraficoCustoPorUnidadeAcumuladoAno || []).length * 50 < 400 ? 400 : listaGraficoCustoPorUnidadeAcumuladoAno.length * 50,
                            }}
                        ></div>
                    )}
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function ExportAnalise({ quantidadeAnos, quantidadeUCs }) {
        const [graficosAtivos, setGraficosAtivos] = useState({
            graficoCustoAnual: true,
            graficoCustoMensal: true,
            tabelaCustoMensal: true,
            graficoCustoJurosPorAtrasoPagamentoAnual: true,
            graficoCustoJurosPorAtrasoPagamentoMensal: true,
            graficoCustoUnidadeAnual: true,
            graficoCustoUnidadeMensal: true,
            tabelaComparativa: true,
            graficoCustoPorUnidadeAcumuladoAno: true,
        });

        const todosMarcados =
            graficosAtivos.graficoCustoAnual &&
            graficosAtivos.graficoCustoMensal &&
            graficosAtivos.tabelaCustoMensal &&
            graficosAtivos.graficoCustoJurosPorAtrasoPagamentoAnual &&
            graficosAtivos.graficoCustoJurosPorAtrasoPagamentoMensal &&
            graficosAtivos.graficoCustoUnidadeAnual &&
            graficosAtivos.graficoCustoUnidadeMensal &&
            graficosAtivos.tabelaComparativa &&
            graficosAtivos.graficoCustoPorUnidadeAcumuladoAno;

        const existeAlgumMarcado =
            graficosAtivos.graficoCustoAnual ||
            graficosAtivos.graficoCustoMensal ||
            graficosAtivos.tabelaCustoMensal ||
            graficosAtivos.graficoCustoJurosPorAtrasoPagamentoAnual ||
            graficosAtivos.graficoCustoJurosPorAtrasoPagamentoMensal ||
            graficosAtivos.graficoCustoUnidadeAnual ||
            graficosAtivos.graficoCustoUnidadeMensal ||
            graficosAtivos.tabelaComparativa ||
            graficosAtivos.graficoCustoPorUnidadeAcumuladoAno;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) =>
                        setGraficosAtivos({
                            graficoCustoAnual: todosMarcados ? false : true,
                            graficoCustoMensal: todosMarcados ? false : true,
                            tabelaCustoMensal: todosMarcados ? false : true,
                            graficoCustoJurosPorAtrasoPagamentoAnual: todosMarcados ? false : true,
                            graficoCustoJurosPorAtrasoPagamentoMensal: todosMarcados ? false : true,
                            graficoCustoUnidadeAnual: todosMarcados ? false : true,
                            graficoCustoUnidadeMensal: todosMarcados ? false : true,
                            tabelaComparativa: todosMarcados ? false : true,
                            graficoCustoPorUnidadeAcumuladoAno: todosMarcados ? false : true,
                        })
                    }
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoAnualCheckbox"
                    label="Custo Total (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoAnual: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoAnual}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoMensalCheckbox"
                    label="Custo Mensal (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoMensal}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoJurosPorAtrasoPagamentoAnualCheckbox"
                    label="Custo de Juros por Atraso de Pagamento por Ano (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoJurosPorAtrasoPagamentoAnual: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoJurosPorAtrasoPagamentoAnual}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoJurosPorAtrasoPagamentoMensalCheckbox"
                    label="Custo de Juros por Atraso de Pagamento (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoJurosPorAtrasoPagamentoMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoJurosPorAtrasoPagamentoMensal}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoUnidadeAnualCheckbox"
                    label="Custo por Unidade em Períodos Definidos (para controle de custo por atividade)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoUnidadeAnual: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoUnidadeAnual}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoUnidadeMensalCheckbox"
                    label="Custo Mensal por Unidade (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoUnidadeMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoUnidadeMensal}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="tabelaComparativaCheckbox"
                    label="Tabela Comparativa para Diferentes Períodos"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            tabelaComparativa: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.tabelaComparativa}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoPorUnidadeAcumuladoAnoCheckbox"
                    label="Custo Acumulado por UC (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoPorUnidadeAcumuladoAno: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoPorUnidadeAcumuladoAno}
                />

                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={async (e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                await handleExport({ graficosAtivos, quantidadeUCs, quantidadeUCsMensal });
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    usuarioLogado: state.auth.usuarioLogado,
    contratoDemanda: state.analise.contratoDemanda,
    listaGraficoCustoAnual: state.analise.listaGraficoCustoAnual,
    listaCustoPorUnidadePeriodo: state.analise.listaCustoPorUnidadePeriodo,
    listaGraficoCustoUnidadeAnual: state.analise.listaGraficoCustoUnidadeAnual,
    listaGraficoCustoUnidadeMensal: state.analise.listaGraficoCustoUnidadeMensal,
    listaGraficoCustoPorUnidadeAcumuladoAno: state.analise.listaGraficoCustoPorUnidadeAcumuladoAno,
    listaGraficoCustoJurosPorAtrasoPagamentoAnual: state.analise.listaGraficoCustoJurosPorAtrasoPagamentoAnual,
    listaGraficoCustoJurosPorAtrasoPagamentoMensal: state.analise.listaGraficoCustoJurosPorAtrasoPagamentoMensal,
    listaUnidadeConsumidora: state.analise.listaUnidadeConsumidora,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDemanda,
            getListaGraficoCustoAnual,
            getListaCustoPorUnidadePeriodo,
            getListaGraficoCustoPorUnidadeMensal,
            getListaGraficoCustoPorUnidadeAcumuladoAno,
            getListarGraficoCustoJurosPorAtrasoPagamentoAnual,
            getListarGraficoCustoJurosPorAtrasoPagamentoMensal,
            getListaGraficoCustoPorUnidadeAnual,
            setFiltro,
            gerarRelatorio,
            setListaFaturasRedirecionamento,
        },
        dispatch
    );
export const AnaliseCusto = withRouter(connect(mapStateToProps, mapDispatchToProps)(AnaliseCustoComponent));
